/* eslint-disable */

//Import Waypoints
import 'waypoints/lib/jquery.waypoints.js'

jQuery(function($) {

  history.scrollRestoration = "manual";

  function ajax_function() {
    var page = posts_loadmore_params.current_page;
      var query = posts_loadmore_params.posts;

      $.ajax({
        url : posts_loadmore_params.ajaxurl, // AJAX handler
        data : {
          'action': 'loadmore', // the parameter for admin-ajax.php
          'query': query, // loop parameters passed by wp_localize_sript()
          'page' : page, // current page
        },
        type : 'POST',
        beforeSend : function ( xhr ) {
          $('.posts_loadmore span').text('Loading...'); // some type of preloader

        },
        success : function( posts ){

          if( posts ) {
            $('.posts_loadmore span').text( 'More posts' );
            $('#posts_container').append( posts ); // insert new posts

            posts_loadmore_params.current_page++;

            if ( posts_loadmore_params.current_page == posts_loadmore_params.max_page ) {
              $('#archive-loadmore').hide(); // if last page, HIDE the button
            } else if(posts_loadmore_params.current_page < posts_loadmore_params.max_page) {
              $('#archive-loadmore').show();
              Waypoint.destroyAll();
              $('.posts_loadmore').waypoint(function () {
                ajax_function()
              },
              { offset: '110%'}
              )
            }

          } else {
            $('.loadmore').hide(); // if no data, HIDE the button as well
          }
        },
      });
    return false;
  }

  $('.posts_loadmore').waypoint(function () {
    ajax_function()
  },
  { offset: '110%'}
  )

  $('.posts_loadmore').on('click', function(e){
    e.preventDefault();
    ajax_function();
  });

});
/* eslint-enable */
